// extracted by mini-css-extract-plugin
export var text = "_4j-0";